










import { Vue, Component } from 'vue-property-decorator';
import CuadraturaOrdenesServicio from '@/pantallas/OrdenesServicio/CuadraturaOrdenesServicio.vue';

@Component({
  components: { CuadraturaOrdenesServicio },
})
export default class CuadraturaOrdenesServicioPantalla extends Vue {}
